import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  legendDescription: {
    color: '#292929',
    fontSize: '10px',
    lineHeight: '14px',
  },
  tenanciesWrapper: {
    margin: '8px 0',
  },
  tenancies: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px', // Equal spacing between all valid items
  },
  tenancyDescription: {
    color: '#292929',
    fontSize: '12px',
    lineHeight: '18px',
    display: 'flex',
    alignItems: 'center',
  },
  tenancyColor: {
    height: '16px',
    width: '16px',
    marginRight: '10px',
  },
});

const AvailabilityLegend = ({ tenancies = [], classes }) => {
  // Filter out entries with empty/null/undefined location or color
  const validTenancies = tenancies.filter(
    (t) => t?.location?.trim() && t?.color?.trim()
  );

  if (validTenancies.length === 0) return null;

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <span className={classes.legendDescription}>
          This provider works from the following locations:
        </span>
      </Grid>

      <Grid item xs={12} className={classes.tenanciesWrapper}>
        <div className={classes.tenancies}>
          {validTenancies.map((tenancy) => (
            <div className={classes.tenancyDescription} key={tenancy.id}>
              <span
                className={classes.tenancyColor}
                style={{ background: tenancy.color }}
              />
              <span>{tenancy.location}</span>
            </div>
          ))}
        </div>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(AvailabilityLegend);
